export default "__VITE_ASSET__rWOMegq$__"